/* eslint-disable react-hooks/exhaustive-deps */
import { Button, Fab, IconButton, Tooltip } from "@mui/material";
import Grid from "@mui/material/Grid2";
import { DataGrid, GridColDef, GridRowsProp } from "@mui/x-data-grid";
import { useDispatch, useSelector } from "src/stateManagement/redux";
import { deletedRequirement } from "src/stateManagement/redux/slices/location/asyncReducers";
import Swal from "sweetalert2";
import AddIcon from "@mui/icons-material/Add";
import { useEffect, useState } from "react";
import { ActiveActivityDto, AddRequirements, RequirementDto } from "./add_requeriments/AddRequirements";
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import EditIcon from '@mui/icons-material/Edit';
import { IUpdateDiagnosticForActivity } from "src/shared/util/updateDataServer";
import SearchIcon from '@mui/icons-material/Search';
import LooksOneIcon from '@mui/icons-material/LooksOne';
import PublishIcon from '@mui/icons-material/Publish';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import { getTranslationsForTable } from "src/shared/traslations";
import moment from "moment";
import { tableStyles } from "src/shared/util/tableStyles";
import MoreVertIcon from "@mui/icons-material/MoreVert";

interface Props {
    originFieldActivityIdFromDiagnostic?: string,
    activeDiagnostic?: IUpdateDiagnosticForActivity
    handleConvertToMain?: (activity: any) => void,
    addRemoveOptimizationActivity?: (activity: any, remove: boolean) => void,
}


export const Requerimientos = ({ originFieldActivityIdFromDiagnostic, activeDiagnostic, handleConvertToMain, addRemoveOptimizationActivity }: Props) => {
    const dispatch = useDispatch();
    const { requirements, locationId, locationName } = useSelector((state) => state.location);

    const [showAddRequirements, setShowAddRequirements] = useState(false);
    const [activeActivity, setActiveActivity] = useState<
          ActiveActivityDto | undefined
      >(undefined);
    
    const [columns, setColumns] = useState<GridColDef[]>([])

    const rows: GridRowsProp = requirements.map((item:any) => {
        return {
            activity: item.activity,
            blocker: item.blocker,
            comments: item.comments,
            executedDate: moment(item.executedDate).format("DD-MM-YYYY"),
            optimizationActivityId: item.optimizationActivityId,
            requiredBy: item.requiredBy,
            requiredById: item.requiredById,
            requiredDate: moment(item.requiredDate).format("DD-MM-YYYY"),
            status: item.status,
            variableId: item.variableId,
        };
    })
    useEffect(() => {
        // if (!activeDiagnostic) return;
        const optimizationActivitiesSelected = activeDiagnostic?.optimizationActivitiesSelected || [];

        setColumns([
            {
                field: "requiredDate",
                headerName: "Fecha Solicitado ",
                flex: 1,
                headerAlign: "center",
                align: "center",
            },
            {
                field: "activity",
                headerName: "Tipo de Actividad",
                flex: 1,
                headerAlign: "center",
                align: "center",
            },
            {
                field: "requiredBy",
                headerName: "Solicitado por",
                flex: 1,
                headerAlign: "center",
                align: "center",
            },
            {
                field: "status",
                headerName: "Estado",
                flex: 1,
                headerAlign: "center",
                align: "center",
            },
            {
                field: "comments",
                headerName: "Comentario",
                flex: 1,
                headerAlign: "center",
                align: "center",
            },
            {
                field: "priority",
                headerName: "Prioridad",
                flex: 1,
                headerAlign: "center",
                align: "center",
            },
            {
                field: "priorityReason",
                headerName: "Razón de Prioridad",
                flex: 1,
                headerAlign: "center",
                align: "center",
            },
            {
                field: "executedDate",
                headerName: "Fecha Ejecutado",
                flex: 1,
                headerAlign: "center",
                align: "center",
            },
            {
                field: "actions",
                headerName: "",
                headerAlign: "center",
                align: "center",
                width: 120,
                renderHeader: () => (
                    <IconButton onClick={() => console.log("Header action")}>
                        <MoreVertIcon />
                    </IconButton>
                ),
                renderCell: (params) => {
                    const id = `${params?.row?.optimizationActivityId}-${params?.row?.activity}`;

                    const selected = optimizationActivitiesSelected.find(
                        (item) => item.id === id
                    );

                    const isMain = optimizationActivitiesSelected.find(
                        (item) => item.id === id && item.main
                    );

                    if (handleConvertToMain && addRemoveOptimizationActivity) {
                        return (
                            <Grid
                                sx={{
                                    display: "flex",
                                    itemAlign: "center",
                                    justifyContent: "center"
                                }}
                            >
                                <IconButton
                                    size="small"
                                    color="info"
                                    onClick={() => {}}
                                >
                                    <SearchIcon fontSize="medium" />
                                </IconButton>
                                <Tooltip title={"Convertir en principal"}>
                                    <IconButton
                                        onClick={() =>
                                            handleConvertToMain(params.row)
                                        }
                                    >
                                        {isMain ? (
                                            <LooksOneIcon color="primary" />
                                        ) : (
                                            <PublishIcon color="disabled" />
                                        )}
                                    </IconButton>
                                </Tooltip>
                                <IconButton
                                    size="small"
                                    color={selected ? "error" : "primary"}
                                    onClick={() =>
                                        addRemoveOptimizationActivity(
                                            params.row,
                                            selected ? false : true
                                        )
                                    }
                                >
                                    {selected ? (
                                        <DeleteForeverIcon fontSize="medium" />
                                    ) : (
                                        <AddCircleOutlineIcon fontSize="medium" />
                                    )}
                                </IconButton>
                            </Grid>
                        );
                    }

                    return (
                        <Grid
                            sx={{
                                display: "flex",
                                itemAlign: "center",
                                justifyContent: "center",
                                mt: 1,
                            }}
                        >
                            <IconButton
                                size="small"
                                color="error"
                                onClick={() =>
                                    handleDeleteRequirement(
                                        params.row.optimizationActivityId,
                                        params.row.variableId
                                    )
                                }
                            >
                                <DeleteForeverIcon fontSize="medium" />
                            </IconButton>
                            <IconButton
                                size="small"
                                color="primary"
                                onClick={() =>
                                    handleEditRow(
                                        params.row.optimizationActivityId
                                    )
                                }
                            >
                                <EditIcon fontSize="medium" />
                            </IconButton>
                        </Grid>
                    );
                },
            },
        ]);

    }, [activeDiagnostic])
   
  
    const handleDeleteRequirement = (
        optimizationActivityId: string,
        variableId: string
    ) => {
        Swal.fire({
            title: "Estas seguro?",
            text: "",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "SI, eliminar!",
        }).then((result) => {
            if (result.isConfirmed) {
                const data = {
                    optimizationActivityId,
                    variableId,
                };

                dispatch(deletedRequirement(data, locationId));

                Swal.fire({
                    title: "Eliminado!",
                    icon: "success",
                });
            }
        });
    };

    const handleShowAddActivity = () => {
        setShowAddRequirements(!showAddRequirements);
    };

    const handleEditRow = (optimizationActivityid: string) => {


        const requirementsActivities = requirements.filter(x => x.optimizationActivityId === optimizationActivityid)

        if (requirementsActivities.length === 0) return;

        const ActiveRequirements: RequirementDto[] = []

        requirementsActivities.forEach((item) => {

            const { variableId, activity, status, blocker, comments } = item;
            const requirement: RequirementDto = {
                id: variableId,
                location: locationName,
                name: activity,
                value: 'Si',
                type: 'Requirement',
                comments,
                blocker,
                status: status,
                priority: item.priority || '',
                priorityReason: item.priorityReason || '',
                priorityExtraReason: item.priorityExtraReason || '',
            };
            ActiveRequirements.push(requirement);
        });

        const activeActivity: ActiveActivityDto = {
            optimizationActivityId: requirementsActivities[0].optimizationActivityId,
            requirements: ActiveRequirements,
            requiredUserId: requirementsActivities[0].requiredById,
            requiredDate: requirementsActivities[0].requiredDate
        }

        setActiveActivity(activeActivity);
        setShowAddRequirements(true);
    }

    const filteredRequirements = originFieldActivityIdFromDiagnostic
        ? requirements.filter((r: any) => r.originFieldActivityId === originFieldActivityIdFromDiagnostic)
        : requirements;

    const paginationModel = { page: 0, pageSize: 10 };
    return (
        <>
            {showAddRequirements && (
                <AddRequirements
                    show={showAddRequirements}
                    setShowPendingActivities={setShowAddRequirements}
                    TabDisable={true}
                    activeActivity={activeActivity}
                    setActiveActivity={setActiveActivity}
                />
            )}
            <Grid>
                <Grid size={12}>
                    <DataGrid
                        rows={getTranslationsForTable([...filteredRequirements], "es", [
                            "status",
                        ])}
                        columns={columns}
                        initialState={{ pagination: { paginationModel } }}
                        pageSizeOptions={[10, 20, 50, 100]}
                        checkboxSelection={false}
                        sx={{
                            mt: 2,
                           ...tableStyles
                        }}
                        getRowId={(row) =>
                            row.optimizationActivityId + row.variableId
                        }
                    />
                </Grid>
                <Grid
                    sx={{
                        display: "flex",
                        justifyContent: "flex-end",
                        mt: 2,
                    }}
                >
                    <Fab
                        size="medium"
                        color="primary"
                        aria-label="add"
                        onClick={handleShowAddActivity}
                    >
                        <AddIcon />
                    </Fab>
                </Grid>
            </Grid>
        </>
    );
};
